// extracted by mini-css-extract-plugin
export default {"container":"MobileDatenschutzScreen_container__lLaPV","gaplessBox":"MobileDatenschutzScreen_gaplessBox__LkFNF"};